import 'slick-carousel';
import 'jquery';

jQuery( ( $ ) => {
	$( '.slick-simple' ).each( function () {
		const $slider = $( this );
		const $container = $slider.closest( '.slick-simple-container' );
		const $controls = $container.find( '.slick-button-container' );

		$slider.slick( {
			mobileFirst: true,
			variableWidth: true,
			centerMode: true,
			infinite: true,
			initialSlide: 0,
			arrows: true,
			dots: true,
			appendDots: $controls,
			appendArrows: $controls,
			prevArrow:
				'<div class="slick-button-prev slick-simple-button-prev"></div>',
			nextArrow:
				'<div class="slick-button-next slick-simple-button-next"></div>',
			customPaging() {
				return '<span class="slick-pagination-bullet"></span>';
			},
			responsive: [
				{
					breakpoint: 767,
					settings: 'unslick',
				},
			],
		} );
	} );
} );
